export default __webpack_public_path__ + "static/media/mobile.b9e6aab0.svg";